import { useEffect } from 'react';
import { useQuery } from 'react-apollo';

import useAuthenticated from '../../hooks/useAuthenticated';
import { MeQuery } from '../../graphql/queries/account';
import { isAdmin } from '../../util/account';
import { isDev } from '../../util/config';

const useDevToolsLimiters = () => {
  const authenticated = useAuthenticated();
  const { data: { me } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  useEffect(() => {
    const rightClickListener = event => {
      event.preventDefault();
      return false;
    };

    const keyboardListener = event => {
      const { repeat, ctrlKey, metaKey, shiftKey, altKey, key } = event;
      if (repeat) {
        return false;
      }

      const isControlPressed = ctrlKey || metaKey;
      // MacOS uses the Command key, which translates to altKey.
      const isShiftPressed = shiftKey || altKey;
      const devToolsKeys = ['I', 'C', 'J'];

      if (key === 'F12') {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      if (isControlPressed && isShiftPressed && devToolsKeys.includes(key)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      return true;
    };

    if (!isDev() && !isAdmin(me)) {
      document.addEventListener('contextmenu', rightClickListener, false);
      document.addEventListener('keydown', keyboardListener, false);
    }

    return () => {
      document.removeEventListener('contextmenu', rightClickListener, false);
      document.removeEventListener('keydown', keyboardListener, false);
    };
  }, [me]);
};

export default useDevToolsLimiters;
